import CancelWithConfirmButtons from '@/components/UI/buttons/CancelWithConfirmButtons'
import { ColorEnum } from '@/constants/color'
import { timeAdjusterShiftValues } from '@/constants/timeAdjuster'
import Chip from '@/features/ui/components/Chip'
import { TimeAdjusterShiftValue } from '@/types/timeAdjuster'
import { ManipulateType } from 'dayjs'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleProp, StyleSheet, Text, TextStyle, View } from 'react-native'

interface TimeAdjusterProps {
    title: string
    time: string
    applyButtonDisabled: boolean
    onTimeShiftPress: (value: number, timeUnit: ManipulateType) => void
    onCancelButton: () => void
    onConfirmButton: () => void
    checkDisabled: (value: TimeAdjusterShiftValue) => boolean
    titleStyle?: StyleProp<TextStyle>
}

const TimeAdjuster: FC<TimeAdjusterProps> = ({
    title,
    time,
    applyButtonDisabled,
    onTimeShiftPress,
    onCancelButton,
    onConfirmButton,
    checkDisabled,
    titleStyle,
}) => {
    const { t } = useTranslation()

    const getTimeUnitTranslation = (timeUnit: string) => {
        switch (timeUnit) {
            case 'hours':
            case 'hour': {
                return t('timeUnit.hour')
            }
            case 'minutes':
            case 'minute': {
                return t('timeUnit.min')
            }
        }
    }

    return (
        <>
            <Text style={[styles.title, titleStyle]}>{title}</Text>
            <View style={styles.container}>
                <Text style={styles.timeText}>{time}</Text>
                {timeAdjusterShiftValues.map(({ value, timeUnit }, index) => {
                    const disabled = checkDisabled({ value, timeUnit })
                    return (
                        <Chip
                            key={index}
                            label={`${value > 0 ? '+' : ''}${value} ${getTimeUnitTranslation(
                                timeUnit
                            )}`}
                            enabledTextColor={value < 0 ? ColorEnum.RED_500 : undefined}
                            disabled={disabled}
                            onPress={() => onTimeShiftPress(value, timeUnit)}
                            style={{ width: 110 }}
                        />
                    )
                })}
            </View>
            <CancelWithConfirmButtons
                onCancel={onCancelButton}
                onConfirm={onConfirmButton}
                applyButtonDisabled={applyButtonDisabled}
                style={{ width: 345 }}
            />
        </>
    )
}

const styles = StyleSheet.create({
    container: {
        flexWrap: 'wrap',
        width: 400,
        flexDirection: 'row',
        justifyContent: 'center',
        marginBottom: 12,
        gap: 8,
    },
    title: {
        fontSize: 16,
        marginBottom: 0,
        textTransform: 'uppercase',
    },
    timeText: {
        fontSize: 22,
        marginBottom: 12,
        textAlign: 'center',
        width: '100%',
    },
})

export default TimeAdjuster
